// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"310":"bd425c4a","453":"35ae0956","539":"d7863596","844":"1c854fbf"}[chunkId] + ".chunk.js";
};